/**
 * Event dates are stored as free text: older rows hold a display string
 * ("December 12, 2026"), newer ones an ISO date ("2026-12-12"). Forms need the
 * ISO form for <input type="date">; everything else only needs to compare days.
 */
const pad = (n: number) => String(n).padStart(2, '0');

/** "YYYY-MM-DD" for a stored date, or '' when it is empty or unreadable. */
export function toIsoDate(raw: string | null | undefined): string {
  if (!raw) return '';
  const text = raw.trim();
  const iso = /^(\d{4}-\d{2}-\d{2})(?:$|[T\s])/.exec(text);
  if (iso) return iso[1];
  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return '';
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
}

/** Sort key: events with no readable date go last. */
export function eventSortKey(date: string | null | undefined): string {
  return toIsoDate(date) || '9999-12-31';
}

/** True when the event's day is today or later (events with no date count as upcoming). */
export function isUpcoming(date: string | null | undefined, today: Date = new Date()): boolean {
  const iso = toIsoDate(date);
  if (!iso) return true;
  return iso >= `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
}
